module.exports = __webpack_public_path__ + "img/download-3-panel-1-INT.f732940d.png";